// extracted by mini-css-extract-plugin
export default {"workflow-outer-div":"workflow_workflow-outer-div__UQDNW","toggle-button-group":"workflow_toggle-button-group__fGyC4","title":"workflow_title__YVzrQ"};